import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { CouponLimitedRequestBody, CouponLimitedResponse } from "./types";

export class CouponLimitedAPI extends BaseAPI<
  CouponLimitedRequestBody,
  CouponLimitedResponse
> {
  protected route = ApiRoutes.coupon.limited;
  protected method = RequestMethod.PUT;
}
